import { Button, Col, Divider, Form, Input, Row, Typography } from 'antd';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { IListColumn, ISortColumn } from 'src/@types/search-params';
import { getSearchActiveSim } from 'src/api/activeSim';
import { getAllDataPackageNew } from 'src/api/register_and_cancel_and_load_package';
import CGridView from 'src/components/CGridView';
import TableContent from 'src/components/CTable';
import { usePermission } from 'src/hooks/usePermission';
import useWindowSize from 'src/hooks/useWindowSize';
import { OpenNewTab } from 'src/shared/common/openNewTab';
import { IOrderStatus } from 'src/shared/interface/package_assigned';
import { dataGet, formatPhoneNumber, parseQueryString } from 'src/utils';
import { simTypeToText } from 'src/utils/sim.enum';
import { getJointSubject, getSimStatus, getUcmCardTypeID } from '../../utils';

interface FormData {
  isdn?: string;
  serial?: string;
  pageIndex?: string;
  pageSize?: string;
}

const SearchSim = () => {
  const size = useWindowSize();
  const location = useLocation();
  const [form] = Form.useForm();
  const [_, setSearchParams] = useSearchParams();
  const [dataSource, setDataSource] = useState();
  const [dataPackage, setDataPackage] = useState<IOrderStatus[]>([]);

  const { PERMISSIONS, hasPermission } = usePermission();

  const fetchActiveSimInfoData = async (params = {}) => {
    try {
      const res = await getSearchActiveSim(params);
      setDataSource(res);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchGetPackageAssigned();
  }, []);

  const fetchGetPackageAssigned = async () => {
    await getAllDataPackageNew().then((res: any) => {
      if (res) {
        const dataPackage: IOrderStatus[] = [{ value: '', label: 'Tất cả' }];
        res?.map((item: any) => {
          dataPackage?.push({
            label: item?.mbfName ?? '',
            value: item?.mbfCode ?? '',
          });
        });
        setDataPackage(dataPackage);
      }
    });
  };

  const columns: IListColumn[] = [
    { name: 'STT', fieldName: 'index', align: 'center', isHideSort: true, width: 50 },
    {
      name: 'SĐT',
      fieldName: 'isdn',
      align: 'center',
      width: 150,
      isHideSort: true,
      renderSpecialCard: (record) => {
        return (
          <Typography.Text
            className={`underline whitespace-nowrap cursor-pointer bg-transparent border-transparent ${
              hasPermission(PERMISSIONS.SUBSCRIBER.SEARCH_DETAIL)
                ? 'text-blue-400'
                : 'text-gray-400'
            } font-semibold`}
            disabled={!hasPermission(PERMISSIONS.SUBSCRIBER.SEARCH_DETAIL)}
          >
            {record.isdn ? '0' + formatPhoneNumber(record.isdn) : ''}
          </Typography.Text>
        );
      },
    },
    {
      name: 'Serial',
      fieldName: 'serial',
      align: 'center',
      width: 150,
      isHideSort: true,
      renderSpecialCard: (record) => {
        return (
          <Typography.Text
            className={`underline whitespace-nowrap cursor-pointer bg-transparent border-transparent ${
              hasPermission(PERMISSIONS.SUBSCRIBER.SEARCH_DETAIL)
                ? 'text-blue-400'
                : 'text-gray-400'
            } font-semibold`}
            disabled={!hasPermission(PERMISSIONS.SUBSCRIBER.SEARCH_DETAIL)}
            onClick={() => handleDetailActiveSim(record)}
          >
            {record?.serial}
          </Typography.Text>
        );
      },
    },
    {
      name: 'Loại SIM',
      fieldName: 'simType',
      isHideSort: true,
      align: 'center',
      width: 120,
      renderSpecialCard: (record) => {
        return (
          <Typography.Text className='Text'>
            {simTypeToText(Number(record.simType) + 1)}
          </Typography.Text>
        );
      },
    },
    {
      name: 'Ngày gán gói ban đầu',
      fieldName: 'kittingDate',
      isHideSort: true,
      align: 'center',
      width: 120,
      renderSpecialCard: (record) => {
        return (
          <Typography.Text className='Text'>
            {dataGet(record, 'kittingDate') ? dataGet(record, 'kittingDate').split(' ')[0] : ''}
          </Typography.Text>
        );
      },
    },
    {
      name: 'Gói cước ban đầu',
      fieldName: 'goodCode',
      isHideSort: true,
      align: 'center',
      width: 120,
      renderSpecialCard: (record) => {
        return <Typography.Text className='Text'>{dataGet(record, 'goodCode')}</Typography.Text>;
      },
    },
    {
      name: 'Tên gói cước ban đầu',
      fieldName: 'goodName',
      isHideSort: true,
      align: 'center',
      width: 120,
      renderSpecialCard: (record) => {
        return (
          <Typography.Text className='Text'>
            {
              dataPackage.find((predicate) => predicate.value === dataGet(record, 'goodCode'))
                ?.label
            }
          </Typography.Text>
        );
      },
    },
    {
      name: 'Ngày kích hoạt',
      fieldName: 'activeDate',
      isHideSort: true,
      align: 'center',
      width: 120,
      renderSpecialCard: (record) => {
        return (
          <Typography.Text className='Text'>
            {dataGet(record, 'activeDate') ? dataGet(record, 'activeDate').split(' ')[0] : ''}
          </Typography.Text>
        );
      },
    },
    {
      name: 'Mã hồ sơ DN',
      fieldName: 'companyCode',
      isHideSort: true,
      align: 'center',
    },
    {
      name: 'Tên hồ sơ DN',
      fieldName: 'companyName',
      isHideSort: true,
      align: 'center',
    },
    {
      name: 'Đối tượng',
      fieldName: 'custType',
      isHideSort: true,
      align: 'center',
      width: 150,
      renderSpecialCard: (record) => {
        return (
          <Typography.Text className='Text'>
            {dataGet(record, 'custType') ? getJointSubject(dataGet(record, 'custType')) : ''}
          </Typography.Text>
        );
      },
    },
    {
      name: 'Tên thuê bao',
      fieldName: 'subName',
      isHideSort: true,
      align: 'center',
      width: 200,
    },
    {
      name: 'Loại giấy tờ',
      fieldName: 'idType',
      isHideSort: true,
      width: 150,
      align: 'center',
      renderSpecialCard: (record) => {
        return (
          <Typography.Text className='Text'>
            {getUcmCardTypeID(Number(dataGet(record, 'idType')))}
          </Typography.Text>
        );
      },
    },
    {
      name: 'Số giấy tờ',
      fieldName: 'idNo',
      isHideSort: true,
      align: 'center',
    },
    {
      name: 'Trạng thái TB',
      fieldName: 'status',
      isHideSort: true,
      width: 150,
      align: 'center',
      renderSpecialCard: (record) => {
        if (Number(record.status)) {
          return <Typography.Text className='Text'>{'Đang hoạt động'}</Typography.Text>;
        } else {
          return <Typography.Text className='Text'>{'Số đã huỷ'}</Typography.Text>;
        }
      },
    },
    {
      name: 'Trạng thái SIM',
      fieldName: 'activate',
      isHideSort: true,
      width: 180,
      align: 'center',
      renderSpecialCard: (record) => {
        return <Typography.Text className='Text'>{getSimStatus(record.activate)}</Typography.Text>;
      },
    },
    {
      name: 'Thao tác',
      fieldName: '',
      renderSpecialCard: (record) => {
        return (
          <Typography.Text
            className={`underline whitespace-nowrap cursor-pointer bg-transparent border-transparent ${
              hasPermission(PERMISSIONS.SUBSCRIBER.SEARCH_DETAIL)
                ? 'text-blue-400'
                : 'text-gray-400'
            } font-semibold`}
            disabled={!hasPermission(PERMISSIONS.SUBSCRIBER.SEARCH_DETAIL)}
            onClick={() => handleDetailActiveSim(record)}
          >
            Chi tiết
          </Typography.Text>
        );
      },
    },
  ];

  const handleSearch = (formValues: FormData) => {
    const { isdn, serial } = formValues;
    const searchParams = {
      ...formValues,
      isdn: isdn ? isdn.replace(/\D/g, '') : undefined,
      serial: serial ? serial.replace(/\D/g, '') : undefined,
    };
    // Chi nhận giá trị serial và isdn là chữ số
    form.setFieldsValue({
      isdn: isdn && isdn.replace(/\D/g, ''),
      serial: serial && serial.replace(/\D/g, ''),
    });
    setSearchParams(queryString.stringify(searchParams));
    fetchActiveSimInfoData(searchParams);
  };

  const defaultValues = {
    isdn: '',
    serial: '',
  };

  const handleDetailActiveSim = (data: any) => {
    OpenNewTab(
      `active-sim/detail?serial=${data?.serial}&phone=${data?.isdn}`,
      `Chi tiết thuê bao ${data?.isdn ? '0' + data?.isdn : ''}`,
    );
  };

  const handleDeleteFilter = () => {
    form.resetFields();
    setSearchParams({});
  };

  return (
    <>
      <div>
        <Form
          form={form}
          onFinish={handleSearch}
          initialValues={defaultValues}
          layout={size.width < 768 ? 'vertical' : 'inline'}
          className='gap-2'
        >
          <Row gutter={[5, 15]} className={'w-full'}>
            <Col span={24} lg={12}>
              <Form.Item name={'isdn'} label={'Số thuê bao'}>
                <Input allowClear placeholder='Nhập số điện thoại'></Input>
              </Form.Item>
            </Col>
            <Col span={24} lg={12}>
              <Form.Item name={'serial'} label={'Sim serial'}>
                <Input allowClear placeholder='Nhập sim serial'></Input>
              </Form.Item>
            </Col>
          </Row>
          <div className={'row-button justify-end flex-wrap-reverse mt-3'}>
            <Button onClick={() => handleDeleteFilter()} className={'m-1'}>
              Xóa tìm kiếm
            </Button>
            <Button type={'primary'} htmlType='submit' className={'m-1'}>
              Tìm kiếm
            </Button>
          </div>
        </Form>
      </div>
      <div className='mt-4'>
        {size.width < 1024 ? (
          <CGridView
            length={dataGet(dataSource, 'results', []).length}
            totalRecord={dataGet(dataSource, 'rowCount', 0) ?? 0}
            columns={columns}
            title={() => <div className='text-xl font-bold my-3'>Danh sách tra cứu thuê bao</div>}
          >
            {dataGet(dataSource, 'results', []) && dataGet(dataSource, 'results', []).length > 0 ? (
              dataGet(dataSource, 'results', []).map((item: any) => {
                return (
                  <div key={'data-row-' + item.id}>
                    <Divider className='border-t-black' />

                    <Row className='mb-6 items-center' gutter={[4, 16]}>
                      {columns.map((ele) => {
                        if (ele.fieldName !== 'index' && ele.fieldName !== 'action') {
                          return (
                            <>
                              <Col span={11} className={`font-bold label`}>
                                <div className='flex gap-2 items-center'>{ele.name}</div>
                              </Col>
                              <Col className='break-words text-right' span={13}>
                                {ele?.renderSpecialCard
                                  ? ele?.renderSpecialCard(item, null, null, null)
                                  : item[`${ele?.fieldName}`]}
                              </Col>
                            </>
                          );
                        } else if (ele.fieldName === 'action') {
                          return (
                            <Col key={'column-' + item.id + ele.fieldName} span={24}>
                              <div className='flex gap-6'>
                                {ele?.renderSpecialCard
                                  ? ele?.renderSpecialCard(item, null, null, null)
                                  : item[`${ele?.fieldName}`]}
                              </div>
                            </Col>
                          );
                        } else {
                          return <></>;
                        }
                      })}
                    </Row>
                  </div>
                );
              })
            ) : (
              <p>{'Không có dữ liệu'}</p>
            )}
          </CGridView>
        ) : (
          <TableContent
            bordered
            // loading={isLoading}
            scroll={{ x: 'max-content' }}
            locale={{ emptyText: 'Không tìm thấy kết quả' }}
            totalRecord={dataGet(dataSource, 'rowCount', 0)}
            dataSource={dataGet(dataSource, 'results', [])}
            columns={columns}
            onPageChange={(pageNumber, pageSize) => {
              const pagination = parseQueryString(location.search);
              fetchActiveSimInfoData({
                ...pagination,
                pageIndex: pageNumber ?? 1,
                pageSize: pageSize ?? 10,
                sortField: pagination.sortField ?? undefined,
                asc: pagination.asc ?? undefined,
              });
            }}
            onSort={(sort: ISortColumn) => {
              const pagination = parseQueryString(location.search);
              handleSearch({
                ...pagination,
                pageIndex: pagination.pageIndex ?? 1,
                pageSize: pagination.pageSize ?? 10,
                sortField: sort.fieldName,
                asc:
                  sort.orderType === 'asc' ? true : sort.orderType === 'desc' ? false : undefined,
              });
            }}
          />
        )}
      </div>
    </>
  );
};

export default SearchSim;
